var React = require('react');

function Node (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon/account"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Search-Listing","transform":"translate(-2.000000, -142.000000)"},React.createElement("g",{"id":"icon/node","transform":"translate(0.000000, 134.000000)"},[React.createElement("rect",{"id":"bot","x":"0","y":"0","width":"24","height":"24","key":0}),React.createElement("rect",{"id":"Rectangle-64","stroke":"#333333","strokeWidth":"1","strokeLinecap":"round","strokeLinejoin":"round","x":"3","y":"9","width":"18","height":"6","rx":"3","key":1})])))]);
}

Node.defaultProps = {"width":"20px","height":"8px","viewBox":"0 0 20 8","version":"1.1"};

module.exports = Node;

Node.default = Node;
